import axios from 'axios';
import VehicleSearchType from '@/shared/constants/VehicleSearchType';
import { OutletId } from '@/shared/models/Outlet';
import { DmsName } from '@/shared/models/common';
import { parseVehicles } from '../converters/vehicleConverters';
import Vehicle from '../models/Vehicle';

export default class VehicleClient {
  static async search(keyword: string, type: VehicleSearchType, outletId: OutletId, dmsConnectionName?: DmsName): Promise<Array<Vehicle>> {
    const params = {
      keyword,
      searchfor: type,
      outletid: outletId,
      ...(!!dmsConnectionName && { dmsconnectionname: dmsConnectionName }),
    };
    const response = await axios.get('/api/mobopro/v1/dealerobjects', { params });
    return parseVehicles(response.data);
  }
}